import { Box, Typography } from "@mui/material";
import { LineChart } from "@mui/x-charts/LineChart";
import { TrendData } from "./types";

export const PerformanceChart = ({ trendData }: { trendData: TrendData }) => {
  const hasRevenueData = trendData.revenue && trendData.revenue.length > 0;
  const hasUnitsData = trendData.units && trendData.units.length > 0;

  if (!hasRevenueData && !hasUnitsData) {
    return (
      <Box sx={{ p: 2, backgroundColor: "action.hover", borderRadius: 1, mt: 2 }}>
        <Typography variant="body2" color="text.secondary">
          No trend data available
        </Typography>
      </Box>
    );
  }

  // Extract periods and values
  const periods = hasRevenueData
    ? trendData.revenue.map((d) => d.period)
    : trendData.units.map((d) => d.period);

  const revenueData = hasRevenueData
    ? trendData.revenue.map((d) => d.value / 1000000) // Convert to millions
    : [];

  const unitsData = hasUnitsData
    ? trendData.units.map((d) => d.value / 1000) // Convert to thousands
    : [];

  return (
    <Box sx={{ mt: 4 }}>
      <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>
        Performance Trends
      </Typography>
      <Box
        sx={{
          backgroundColor: "background.paper",
          borderRadius: 1,
          p: 3,
          border: "1px solid",
          borderColor: "divider",
          boxShadow: "0 1px 3px rgba(0, 0, 0, 0.08)",
        }}
      >
        <LineChart
          xAxis={[
            {
              data: periods,
              scaleType: "band",
              label: "Period",
            },
          ]}
          yAxis={[
            {
              id: "revenue",
              label: "Revenue ($M)",
              position: "left",
            },
            {
              id: "units",
              label: "Units (K)",
              position: "right",
            },
          ]}
          series={[
            ...(hasRevenueData
              ? [
                  {
                    id: "revenue",
                    data: revenueData,
                    label: "Revenue ($M)",
                    yAxisId: "revenue",
                    color: "#1565c0",
                    showMark: true,
                  },
                ]
              : []),
            ...(hasUnitsData
              ? [
                  {
                    id: "units",
                    data: unitsData,
                    label: "Units (K)",
                    yAxisId: "units",
                    color: "#2e7d32",
                    showMark: true,
                  },
                ]
              : []),
          ]}
          grid={{ horizontal: true, vertical: false }}
          sx={{
            "& .MuiChartsGrid-line": {
              stroke: "#e0e0e0",
              strokeWidth: 1,
            },
            "& .MuiChartsAxis-line": {
              stroke: "#bdbdbd",
            },
            "& .MuiChartsAxis-tick": {
              stroke: "#bdbdbd",
            },
          }}
          height={350}
          margin={{ left: 70, right: 70, top: 20, bottom: 60 }}
        />
      </Box>
    </Box>
  );
};
